import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';

// Legacy class-based interceptor for backward compatibility
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private readonly _router = inject(Router);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        switch (err.status) {
          case 404:
            this._router.navigateByUrl('404');
            break;
          case 401:
            this._router.navigateByUrl('forbidden');
            break;
          case 0:
            this._router.navigateByUrl('internal-error');
        }

        return throwError(() => err);
      })
    );
  }
}

// Standalone HTTP interceptor function
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      switch (err.status) {
        case 404:
          router.navigateByUrl('404');
          break;
        case 401:
          router.navigateByUrl('forbidden');
          break;
        case 0:
          router.navigateByUrl('internal-error');
      }

      return throwError(() => err);
    })
  );
};
